<div class="modal-container op-picker">
  <div mat-dialog-title
       class="modal-header">
    <h1 class="modal-title">Assign operations</h1>
  </div>
  <div mat-dialog-content
       class="modal-content">

    <div class="op-picker-filters">
      <button class="op-picker-chip"
              [class.active]="effectFilter === 'all'"
              (click)="onEffectFilterClicked('all')">All</button>
      <button class="op-picker-chip"
              [class.active]="effectFilter === 'enables'"
              (click)="onEffectFilterClicked('enables')">Enables</button>
      <button class="op-picker-chip"
              [class.active]="effectFilter === 'restricts'"
              (click)="onEffectFilterClicked('restricts')">Restricts</button>
      <button *ngIf="hasUnclassified"
              class="op-picker-chip"
              title="Operations whose names don't follow the enable/disable convention"
              [class.active]="effectFilter === 'other'"
              (click)="onEffectFilterClicked('other')">Other</button>
      <span class="op-picker-spacer"></span>
      <input class="datex-textbox op-picker-search"
             placeholder="Filter operations"
             [(ngModel)]="search"
             (ngModelChange)="onSearchChanged()" />
    </div>

    <div class="op-picker-list">
      <div *ngFor="let group of groups"
           class="op-picker-group">
        <div class="op-picker-group-header">
          <mat-checkbox class="datex-checkbox"
                        color="primary"
                        [checked]="isGroupSelected(group)"
                        [indeterminate]="isGroupPartiallySelected(group)"
                        (change)="onGroupToggled(group)"></mat-checkbox>
          <span class="op-picker-group-title">{{group.moduleLabel}} · {{group.rows.length}}</span>
        </div>
        <div *ngFor="let row of group.rows"
             class="op-picker-row"
             [class.selected]="isSelected(row)"
             (click)="onRowToggled(row)">
          <mat-checkbox class="datex-checkbox"
                        color="primary"
                        [checked]="isSelected(row)"
                        (click)="$event.stopPropagation()"
                        (change)="onRowToggled(row)"></mat-checkbox>
          <span class="op-picker-name">{{row.operation.name}}</span>
          <span *ngIf="row.effect !== 'unknown'"
                class="roles-effect-pill"
                [class.enables]="row.effect === 'enables'"
                [class.restricts]="row.effect === 'restricts'">{{row.effect}}</span>
          <span *ngIf="row.roleCount !== null && row.roleCount > 0"
                class="op-picker-rolecount"
                title="Roles already carrying this operation">{{row.roleCount}} {{row.roleCount === 1 ? 'role' : 'roles'}}</span>
          <span class="op-picker-desc">{{row.operation.description}}</span>
        </div>
      </div>
      <div *ngIf="groups.length === 0"
           class="op-picker-none">No operations match the current filters.</div>
    </div>
  </div>
  <div mat-dialog-actions
       class="modal-toolbar commands op-picker-footer">
    <span class="op-picker-count">{{selectedCount}} selected</span>
    <button mat-button
            class="datex-button primary"
            [disabled]="selectedCount === 0"
            (click)="onSaveClicked()">Assign</button>
    <button mat-button
            class="datex-button secondary"
            (click)="onCancelClicked()">
      Cancel
    </button>
  </div>
</div>
